
class UserHandlerClass {

	constructor() {
		// Preload data, so its available, when needed.
		this.getData();
	}

	getData = () => {
		if ( window.ACL_USER_DATA ) {
			return window.ACL_USER_DATA;
		}

		window.ACL_USER_DATA = fetch( '/index.php?cl=userdata', { method: 'GET', credentials: 'include', mode: 'no-cors' } ).then( res => res.json() );
		return window.ACL_USER_DATA;
	}
}


export default new UserHandlerClass();
